import React, { useState } from "react";
import { ChevronDown, Mail } from "lucide-react";
import { useLang } from "@/context/LangContext";
import { getFAQ } from "@/data/faqContent";

export default function FAQ_Page() {
  const [open, setOpen] = useState({});
  const { lang } = useLang();
  const { tr, sections } = getFAQ(lang);

  return (
    <div className="max-w-3xl mx-auto px-4 md:px-6 py-10" data-testid="faq-page">
      <div className="mb-8">
        <span className="wb-tag">{tr.pageTag}</span>
        <h1 className="font-display font-black text-3xl md:text-4xl mt-2">{tr.pageTitle}</h1>
        <p className="text-sm text-zinc-400 mt-2">{tr.pageSub}</p>
      </div>

      <div className="space-y-8">
        {sections.map((sec) => (
          <section key={sec.cat} data-testid={`faq-section-${sec.cat.toLowerCase()}`}>
            <h2 className="font-display font-bold text-lg flex items-center gap-2 mb-3 text-gold-400">
              <sec.icon className="w-4 h-4" /> {sec.cat}
            </h2>
            <div className="space-y-2">
              {sec.items.map((it, i) => {
                const key = `${sec.cat}-${i}`;
                const isOpen = !!open[key];
                return (
                  <div key={key} className="border border-zinc-800 bg-[var(--wb-surface)]">
                    <button
                      data-testid={`faq-q-${key}`}
                      onClick={() => setOpen({ ...open, [key]: !isOpen })}
                      className="w-full text-left p-4 flex items-center justify-between gap-2 hover:bg-zinc-900/40 transition-colors"
                    >
                      <span className="font-display font-bold text-sm">{it.q}</span>
                      <ChevronDown className={`w-4 h-4 text-gold-500 transition-transform ${isOpen ? "rotate-180" : ""}`} />
                    </button>
                    {isOpen && (
                      <div className="px-4 pb-4 text-sm text-zinc-300 leading-relaxed border-t border-zinc-800" data-testid={`faq-a-${key}`}>
                        <div className="pt-3">{it.a}</div>
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          </section>
        ))}
      </div>

      <div className="mt-12 border-t border-zinc-800 pt-6 text-center">
        <Mail className="w-5 h-5 text-gold-400 mx-auto mb-2" />
        <p className="text-sm text-zinc-400">{tr.noAnswer}</p>
        <a href="mailto:info@saubereko.eu" className="text-gold-400 font-display font-bold text-base">{tr.askLabel}</a>
      </div>
    </div>
  );
}
